/*
 * @Author: Duanjiaojiao
 * @Date: 2023-02-28 16:57:29
 * @LastEditors: Duanjiaojiao
 * @LastEditTime: 2023-04-04 14:55:41
 * @Description:
 * @FilePath: /BM-Main/src/apiData/helpsale/d2d-gps.js
 * @props:
 */
import httpClient from '@/utils/http'
import { zzHost } from '@/conf/hosts.conf'

import { geocoderApi } from '@/components/Map/t-map'

const API = {
  locationInformationData: `${zzHost}/zzopen/geolibrary/geoposition`, // 腾讯地址信息转成转转的
  addAddress: `${zzHost}/zzopen/userapi/adduseraddress`, // 新增地址
  updateAddress: `${zzHost}/zzopen/userapi/upduseraddress`, // 更新地址
  getCountInfo: `${zzHost}/zzopen/c2b_recovery_order/queryLocationNextLevelList`, // 获取区县数据
  getLocationCity: `${zzHost}/zzopen/c2b_recovery_order/getCityInfoByClientIp`, // 获取所在城市信息
  getUserIpInfo: `${zzHost}/zzopen/zzbmlogic/getUserIpInfo`, // 获取用户ip信息
  applyOpenDoor: `${zzHost}/zzopen/zzbmlogic/applyOpenDoor`, // 申请开通上门
  grantApplyDoorCoupon: `${zzHost}/zzopen/zzbmlogic/grantApplyDoorCoupon`// 申请开通上门
}

export const getUserIpInfoAjax = (params) => {
  return httpClient.get(API.getUserIpInfo, params)
}

// 腾讯地址信息转成转转的
export const getLocationInfomation = (params) => {
  return httpClient.post(API.locationInformationData, params)
}

export const addAddressAjax = (params) => {
  return httpClient.get(API.addAddress, params)
}

export const updateAddressAjax = (params) => {
  return httpClient.post(API.updateAddress, params)
}

export const getCountInfoAjax = (params) => {
  return httpClient.post(API.getCountInfo, params)
}

export const getLocationCityAjax = (params) => {
  return httpClient.post(API.getLocationCity, params)
}

// 地址过滤省市区
export const filterAddressHandle = (address, district) => {
  if (district && address?.indexOf(district) > -1) {
    return address.split(district)[1]
  }
  return address
}

// gps信息转地址
export const transformGpsToAddress = async(latLngInfo) => {
  const { lat, lon } = latLngInfo || {}
  if (!+lat && !+lon) return
  try {
    // 1.调腾讯gps转地址
    const resultObj = await geocoderApi({
      location: `${lat},${lon}`
    })
    const { result = {} } = resultObj || {}
    if (!result) return
    const { address, ad_info = {}, formatted_addresses = {}, location = {} } = result
    const { adcode, province, city, district } = ad_info
    const { lng: geoLon, lat: geoLat } = location
    const filterAddress = filterAddressHandle(address, district)
    const { recommend = '' } = formatted_addresses
    const params = {
      opType: 1,
      geoLon,
      geoLat,
      detail: `${filterAddress}${recommend}`,
      positionType: 'TENCENT',
      adcode,
      pname: province,
      cityname: city,
      adname: district
    }
    // 2.腾讯地址转成转转的

    /**
       * 为什么腾讯gps转地址的信息不能直接使用？
       * 因为， 行政区划 结构 包括 转转区划ID 、国标码adcode等。
       * 腾讯返回的接口里 有adcode , 匹配转转adcode，然后间接拿到 转转区划ID。
       * 用户地址里存的是 转转区划ID。
       */
    const res = await getLocationInfomation(params)
    const addressData = {
      ...dealResData(res),
      addressDetail: `${filterAddress} ${recommend}`,
      gpsBuild: recommend || address || '',
      gpsLon: geoLon,
      gpsLat: geoLat,
      addressDesc: address,
      id: null
    }
    console.log('addressData: ', addressData);
    return addressData
  } catch (e) {
    console.log('e: ', e);
  }
}
const dealResData = (res) => {
  const { county = {}, province = {}, city = {} } = res || {}
  const addressData = {
    proId: province.zzId || null,
    proName: province.zzName || '',
    cityId: city.zzId || null,
    cityName: city.zzName || '',
    countyId: county.zzId || null,
    countyName: county.zzName || ''
  }
  return addressData
}

// 申请开通
export const applyOpenD2DAjax = (params) => {
  return httpClient.get(API.applyOpenDoor, params).then(res => res)
}
// 上门开通成功，用户可领券
export const grantApplyDoorCouponAjax = (params) => {
  return httpClient.get(API.grantApplyDoorCoupon, params).then(res => res)
}
